module.exports = __webpack_public_path__ + "static/media/21d-01-HOME_ST-2021-200x300cm-oleo-sobre-madera.83aa8144.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gallery/21d/21d-01-HOME_ST-2021-200x300cm-oleo-sobre-madera.jpg
// module id = 258
// module chunks = 0